module.exports = __webpack_public_path__ + "img/portrait-087.9ea13797.jpg";